import { excludeNullOrUndefined } from 'checkout/utils'
import { useAppSelector } from 'hooks/reduxHooks'
import { useMemo } from 'react'
import useOfferListKey from './useOfferListKey'

function useOfferMetaDataList(filters?: App.OfferListFilters): Array<App.OfferListMetaData> {
  const offerMetaDataKey = useOfferListKey(filters)
  const offerMetaData = useAppSelector(state => state.offer.searchResultMetadata.offerMetaData[offerMetaDataKey])

  return useMemo(() => Object.values(offerMetaData ?? {}).filter(excludeNullOrUndefined), [offerMetaData])
}

export default useOfferMetaDataList
